import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ListViewContainer = styled.div`
  height: calc(100% - 40px);
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin: 24px 24px -24px 24px;
`;
